import React from 'react';
import Icon from '../../../components/AppIcon';

const KnowledgeAreaBreakdown = ({ knowledgeAreas }) => {
  const getPerformanceColor = (percentage) => {
    if (percentage >= 80) return 'bg-success';
    if (percentage >= 60) return 'bg-warning';
    return 'bg-error';
  };

  const getPerformanceIcon = (percentage) => {
    if (percentage >= 80) return 'TrendingUp';
    if (percentage >= 60) return 'Minus';
    return 'TrendingDown';
  };

  return (
    <div className="bg-card rounded-xl p-6 md:p-8 shadow-elevation-2 animate-fade-in">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-xl md:text-2xl font-semibold text-foreground mb-2">
            Knowledge Area Performance
          </h3>
          <p className="text-sm md:text-base text-muted-foreground">
            Breakdown by BABOK domains
          </p>
        </div>
        <div className="w-10 h-10 md:w-12 md:h-12 rounded-lg bg-secondary/20 flex items-center justify-center">
          <Icon name="BarChart3" size={24} className="text-secondary" />
        </div>
      </div>
      <div className="space-y-4 md:space-y-6">
        {knowledgeAreas?.map((area, index) => (
          <div key={index} className="bg-muted/30 rounded-lg p-4 md:p-6 border border-border transition-smooth hover:shadow-elevation-1">
            <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-4 mb-4">
              <div className="flex-1">
                <div className="flex items-center gap-3 mb-2">
                  <h4 className="text-base md:text-lg font-semibold text-foreground">
                    {area?.name}
                  </h4>
                  <div className={`w-8 h-8 rounded-full ${getPerformanceColor(area?.percentage)} flex items-center justify-center`}>
                    <Icon name={getPerformanceIcon(area?.percentage)} size={16} color="white" />
                  </div>
                </div>
                <p className="text-xs md:text-sm text-muted-foreground">
                  {area?.questionsAttempted} questions attempted
                </p>
              </div>
              <div className="flex items-center gap-4">
                <div className="text-right">
                  <p className="text-2xl md:text-3xl font-bold text-foreground data-text">
                    {area?.percentage}%
                  </p>
                  <p className="text-xs md:text-sm text-muted-foreground">
                    {area?.correct}/{area?.questionsAttempted}
                  </p>
                </div>
              </div>
            </div>

            <div className="w-full h-3 bg-muted rounded-full overflow-hidden">
              <div
                className={`h-full ${getPerformanceColor(area?.percentage)} transition-all duration-500`}
                style={{ width: `${area?.percentage}%` }}
              />
            </div>

            {area?.weakTopics && area?.weakTopics?.length > 0 && (
              <div className="mt-4 pt-4 border-t border-border">
                <p className="text-xs md:text-sm font-medium text-muted-foreground mb-2">
                  Topics needing improvement:
                </p>
                <div className="flex flex-wrap gap-2">
                  {area?.weakTopics?.map((topic, idx) => (
                    <span
                      key={idx}
                      className="px-3 py-1 bg-error/10 text-error text-xs rounded-full"
                    >
                      {topic}
                    </span>
                  ))}
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default KnowledgeAreaBreakdown;